import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import LoadingMark from '../../../components/ui/LoadingMark';
import { FAVORITE_TYPE_USER } from '../../../services/favoriteModelsService';
import { useFavoriteModels } from '../../../context/FavoriteModelsContext';
import ModelLibraryCardShell from './ModelLibraryCardShell';
import ModelListItem from './ModelListItem';

const PREVIEW_LIMIT = 10;

const UserModelsCard = ({ templates = [], isLoading = false }) => {
  const navigate = useNavigate();
  const { isFavorite, toggleFavorite, isSaving } = useFavoriteModels();

  const visibleTemplates = useMemo(
    () => templates.slice(0, PREVIEW_LIMIT),
    [templates]
  );

  const handleOpenTemplate = (template) => {
    const templateId = template?.template_id ?? template?.id;
    if (!templateId) return;
    navigate(
      `/contract-generator?user_template_id=${encodeURIComponent(String(templateId))}`
    );
  };

  return (
    <ModelLibraryCardShell>
      <div className="flex flex-col gap-3 mb-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-muted/50 shrink-0">
            <Icon name="LayoutTemplate" size={18} className="text-primary" />
          </div>
          <div className="min-w-0 flex-1">
            <h2 className="text-base font-semibold text-foreground tracking-tight truncate">
              Meus Modelos
            </h2>
            <p className="text-xs text-muted-foreground truncate">
              Modelos personalizados
            </p>
          </div>
        </div>

        <Button
          type="button"
          variant="default"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          fullWidth
          onClick={() => navigate('/create-template')}
        >
          Adicionar Modelo
        </Button>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto space-y-1 mb-3 pr-0.5">
        {isLoading ? (
          <div className="flex justify-center py-8">
            <LoadingMark
              size="xs"
              message="Carregando..."
              messageClassName="text-xs"
            />
          </div>
        ) : visibleTemplates.length === 0 ? (
          <p className="text-xs text-muted-foreground py-6 text-center">
            Você ainda não criou modelos personalizados.
          </p>
        ) : (
          visibleTemplates.map((template) => {
            const templateId = template.template_id ?? template.id;
            return (
              <ModelListItem
                key={templateId}
                label={template.name || 'Sem nome'}
                onClick={() => handleOpenTemplate(template)}
                isFavorite={isFavorite(FAVORITE_TYPE_USER, templateId)}
                favoriteDisabled={isSaving}
                onToggleFavorite={() =>
                  toggleFavorite(FAVORITE_TYPE_USER, templateId)
                }
              />
            );
          })
        )}
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        fullWidth
        onClick={() => navigate('/user-templates')}
      >
        Ver todos
      </Button>
    </ModelLibraryCardShell>
  );
};

export default UserModelsCard;
